const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

export class Vendedor {
  static get ESTATUS_LIST() {
    return [
      {
        value: ESTATUS_ACTIVO,
        label: ESTATUS_ACTIVO_LABEL,
      },
      {
        value: ESTATUS_INACTIVO,
        label: ESTATUS_INACTIVO_LABEL,
      },
    ];
  }
  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  }

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "Id" },
      { value: "Nombre", label: "Nombre" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ];
    return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
}
